import { useTranslation } from "next-i18next";
import { useMemo } from "react";
import { sortListByAttribute } from "./sort-utils";

export type CargillRoles = { name: string }[];

/**
 * Gets roles list based on translations, sorted for forms.
 * @returns a list of roles
 */
export function useCargillRoles() {
  const { t, i18n } = useTranslation();
  const data = useMemo(() => {
    const other = t("request_access:more_information.other");
    const list = t("request_access:employee_access.cargill_role_list");
    const json = JSON.parse(list) as CargillRoles;
    const sorted = sortListByAttribute("name", json, other);
    return sorted;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, t]);

  return data;
}
